// extracted by mini-css-extract-plugin
export default {"header-box":"Ranking_header-box__cUY5W","value-box":"Ranking_value-box__9aair","word-break":"Ranking_word-break__oMpiQ"};